import { render, staticRenderFns } from "./BuildingConfigs.vue?vue&type=template&id=8683e0cc"
import script from "./BuildingConfigs.vue?vue&type=script&lang=ts"
export * from "./BuildingConfigs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports